<template>
    <span
        :class="[
            'tooltip-container',
            {
                top: position === 'top',
                right: position === 'right',
                bottom: position === 'bottom',
                left: position === 'left',
                shown
            }
        ]">
        <font-awesome-icon :icon="icon" :class="['tooltip-icon', classes]"></font-awesome-icon>
        <span class="tooltip-text">{{ text }}</span>
    </span>
</template>
<script>
// const positionMap = {
// 	top: {},
// 	right: {},
// 	bottom: {},
// 	left: {}
// }
export default {
	props: {
		text: String,
		icon: {
			type: Array,
			default: () => ['fas', 'info-circle'],
			required: false
		},
		classes: {
			type: String,
			required: false
		},
		shown: {
			type: Boolean,
			default: false,
			required: false
		},
		position: {
			type: String,
			default: 'right',
			required: false
		}
	}
}
</script>
<style lang="scss" scoped>
// $bgColor: rgba(0,0,0,0.85);
$bgColor:rgba(83, 123, 177, 0.95);
$textColor: white;
.tooltip-container {
    position:relative;
    .tooltip-icon {
        + .tooltip-text {
            // display: none;
            opacity: 0;
            pointer-events:none;
            position:absolute;
            min-width: 190px;
            max-width: 250px;
            height:auto;
            background-color:$bgColor;
            color:$textColor;
            padding: 0.5em;
            @include font-size(7);
            border-radius:3px;
            line-height:1.2;
            transition: transform 0.25s ease-out 0.25s, opacity 0.25s ease-out 0.25s;
        }

        &:hover {
            + .tooltip-text {
                display: block;
                opacity: 1;
                transform:translateX(0);
                transform:translateY(0);
                z-index: 99;
                // transition: transform 0.25s ease-out 0.25s, opacity 0.25s ease-out 0.25s;
            }
        }
    }

    &.shown {
        .tooltip-icon + .tooltip-text {
            display: block;
        }
    }
    $d: 15px;
    &.top .tooltip-icon + .tooltip-text {
        min-width: 250px;
        top:auto;
        left:0;
        right:auto;
        bottom:20px;
        margin-left:-120px;
        transform:translateY(-1*$d);
    }
    &.right .tooltip-icon + .tooltip-text {
        top:-100%;
        left:20px;
        transform:translateX($d);
    }
    &.bottom .tooltip-icon + .tooltip-text {
        min-width: 250px;
        top:20px;
        bottom:auto;
        left:0;
        right:auto;
        margin-left:-120px;
        transform:translateY($d);
    }
    &.left .tooltip-icon + .tooltip-text {
        top:-100%;
        right:20px;
        transform:translateX(-1*$d);
    }
    &.top,
    &.right,
    &.bottom,
    &.left {
        .tooltip-icon:hover + .tooltip-text {
            transform:translateX(0);
            transform:translateY(0);
        }
    }
}
</style>
